<template>
  <div class="hello flex">
    <info @showdialogVisible="showdialogVisible" ref="child" :data="childInfo"></info>
    <div style="width:1050px!important;text-align: left;margin-top:20px;">

      <button class="add" @click="add()">添加</button>
      <!-- <div class="flex one">
        <span>所在省份：</span>
        <div>
          <el-select v-model="formInline.province_name" @change="change01($event)" style="width: 150px;">
            <el-option v-for="item in province" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="formInline.city_name" @change="change12($event)" style="width: 150px;">
            <el-option v-for="item in city" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="formInline.county_name" @change="change11($event)" style="width: 150px;">
            <el-option v-for="item in county" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline score">
        <!-- <el-form-item label="学校">
          <el-input v-model="formInline.school" placeholder="学校"></el-input>
        </el-form-item> -->
        <el-form-item label="年级">
          <el-select v-model="formInline.grade" placeholder="年级" style="width: 200px;">
            <el-option v-for="(item,index) in data.grade_list" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="班级">
          <el-input v-model="formInline.class" style="width: 100px;" placeholder="班级"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="clear">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" stripe style="width: 1050px!important;margin-bottom: 100px;">
        <el-table-column prop="school" label="学校">
        </el-table-column>
        <el-table-column prop="class" label="班级" width="50px">
        </el-table-column>
        <el-table-column prop="exam_at" label="考试时间">
        </el-table-column>
        <el-table-column prop="title" label="考试类型">
        </el-table-column>
        <el-table-column label="分数" width="400px">
          <templete slot-scope="scope" class="score">
            <span style="margin-right: 10px;width: 70px;"
              v-for="(item,index) in scope.row.scores">{{item.type_zn}}：{{scope.row.scores[index].score}}</span>
            <!-- <span style="margin-right: 10px;"
              v-if="scope.row.scores[1]&&scope.row.scores[1].score">数学：{{scope.row.scores[1].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[2]&&scope.row.scores[2].score">英语：{{scope.row.scores[2].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[3]&&scope.row.scores[3].score">物理：{{scope.row.scores[3].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[4]&&scope.row.scores[4].score">化学：{{scope.row.scores[4].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[5]&&scope.row.scores[5].score">生物：{{scope.row.scores[5].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[6]&&scope.row.scores[6].score">历史：{{scope.row.scores[6].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[7]&&scope.row.scores[7].score">政治：{{scope.row.scores[7].score}}</span>
            <span style="margin-right: 10px;"
              v-if="scope.row.scores[8]&&scope.row.scores[8].score">地理：{{scope.row.scores[8].score}}</span> -->
          </templete>
        </el-table-column>
        <el-table-column prop="total" label="总分">
        </el-table-column>
        <el-table-column prop="total_max" label="操作">
          <templete slot-scope="scope" class="score">
            <span style="color: #C10B17;cursor: pointer;" @click="goDetail(scope.row)">查看详情</span>
            <!--   <span style="color: #C10B17;" @click="goDetail(scope.row)"></span> -->
          </templete>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
        style="text-align: center;margin-bottom: 20px;" @current-change="current_change">
      </el-pagination>
    </div>
    <el-dialog title="请输入学校信息" :visible.sync="dialogVisible" width="600px">
      <div class="flex one">
        <span>所在省份：</span>
        <div>
          <el-select v-model="user.province_name" @change="change0($event,form)" style="width: 150px;">
            <el-option v-for="item in province" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="user.city_name" @change="change($event)" style="width: 150px;">
            <el-option v-for="item in city" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="user.county_name" @change="change1($event)" style="width: 150px;">
            <el-option v-for="item in county" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="one">
        <span>学校名称:</span>
        <el-input style="width: 200px;" v-model="user.school" placeholder="请输入内容"></el-input>
      </div>
      <div class="flex one">
        <span>年级：</span>
        <div>
          <el-select v-model="user.grade_name" @change="changeGrade($event)" style="width:200px;">
            <el-option v-for="item in data.grade_list" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="one">
        <span>班级:</span>
        <el-input style="width: 200px;" v-model="user.class" placeholder="请输入内容"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import info from '../../../components/me/growthInfo.vue'
  export default {
    data() {
      return {
        dialogVisible: false,
        data: [],
        tableData: [],
        userInfo: [],
        user: [],
        newuser: {},
        options: [],
        province: [],
        city: [],
        county: [],
        formInline: {},
        new_user_info: [],
        page: 1,
        total: '',
        childInfo: []
      }
    },
    components: {
      info
    },
    created() {
      this.$http.userExamScoreHistory().then(res => {
        this.tableData = res.data.list
        this.total = res.data.count
        this.tableData.forEach(item => {
          item.scores = JSON.parse(item.scores)
        })
      })
      this.$http.userExamInfo().then(res => {
        this.data = res.data
        this.childInfo = res.data.info
        if (res.data.last_score && res.data.last_score != '') {
          this.user = res.data.last_score
          this.new_user_info = res.data.last_score
          this.options = res.data
        } else {
          this.$http.getUserInfo().then(res => {
            this.user = res.data
            this.newuser = res.data
          })
        }

      })

      this.$http.getareaList().then(res => {
        this.province = res.data.list
      })
    },
    mounted() {

    },
    methods: {
      showdialogVisible(e) {
        this.dialogVisible = true
      },
      clear() {
        this.formInline = {}
        this.$http.userExamScoreHistory().then(res => {
          this.tableData = res.data.list
          this.total = res.data.count
          this.tableData.forEach(item => {
            item.scores = JSON.parse(item.scores)
          })
        })
      },
      current_change(e) {
        this.$http.userExamScoreHistory({
          page: e
        }).then(res => {
          this.tableData = res.data.list
          this.total = res.data.count
          this.tableData.forEach(item => {
            item.scores = JSON.parse(item.scores)
          })
        })
      },
      onSubmit() {
        this.$http.userExamScoreHistory(this.formInline).then(res => {
          this.tableData = res.data.list
          this.tableData.forEach(item => {
            item.scores = JSON.parse(item.scores)
          })
        })
        console.log(this.formInline)
      },
      goDetail(item) {
        this.$router.push('/growthDetail?id=' + item.id)
      },
      submit() {
        this.$http.userExamInfoSet(this.user).then(res => {
          this.$http.userExamInfo().then(res => {
            this.childInfo = res.data.info
          })
        })
        this.dialogVisible = false
      },
      add() {
        // this.dialogVisible = true

        this.$router.push('/addRecord')
      },
      change1(e) {
        this.user.county_id = e
      },
      change(e) {
        this.user.city_id = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.county = res.data.list
        })
      },
      change0(e, form) {
        this.user.city = null
        this.user.county = null
        this.user.city_name = ''
        this.user.county_name = ''
        this.user.province_id = e
        console.log(this.data)
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.city = res.data.list
        })
      },
      changeGrade(e) {

      },
      //* 列表筛选的方法 */
      change11(e) {
        this.formInline.county_id = e
      },
      change12(e) {
        this.formInline.city_id = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.county = res.data.list
        })
      },
      change01(e) {
        console.log(e)
        this.formInline.province_id = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.city = res.data.list
        })
      },

    }
  }
</script>

<style scoped lang="scss">
  $color:#C10B17;

  .dialog-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  .score {
    margin-top: 20px;

    button {
      background-color: #C10B17;
      color: #FFFFFF;
      border: none;
    }
  }

  .add {
    width: 100%;
    height: 50px;
    background-color: #C10B17;
    color: #FFFFFF;
    border-radius: 10px;
    font-size: 16px;
    // margin-bottom: 30px;
  }

  .one {
    margin: 20px 0;
    text-align: left;

    span {
      display: inline-block;
      width: 80px;
    }
  }

  .hello {
    justify-content: space-between;
    align-items: flex-start;
  }

  .edit {
    width: 147px;
    height: 33px;
    border: 1px solid #C10B17;
    border-radius: 6px;
    background-color: #FFFFFF;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #C10B17;
    margin-top: 15px;
  }

  .info {
    min-width: 175px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;
    border: 1px solid #EDEDED;
    text-align: center;
    padding-bottom: 20px;



    &>p {
      width: 100%;

      margin: 20px 0px 20px 0px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }

    .score {

      margin-right: 10px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/view/me/growthRecord/growthRecord.vue